/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Formik, FormikHelpers } from 'formik';

import { useHistory } from 'react-router-dom';

import { Button } from 'primereact/button';
import { Calendar, CalendarChangeEvent } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { SelectButton } from 'primereact/selectbutton';
import { Tooltip } from 'primereact/tooltip';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import {
  Container,
} from './styles';

interface SearchData {
  inCharge: string;
  topic: string;
  description: string;
  proc_tipo: string;
  proc_data_ajuiz_inicio: Date;
  proc_data_ajuiz_final: Date;
}

interface IInChargeType {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any;
}

interface IOptions {
  label: string;
  value: string;
  disabled: boolean;
  workingsector: string;
}

const SearchSchedule:React.FC = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const initialValues: SearchData = {
    inCharge: 'global|0',
    topic: '',
    description: '',
    proc_tipo: 'todos',
    proc_data_ajuiz_inicio: new Date(),
    proc_data_ajuiz_final: new Date(),
  };

  const [typeId, setTypeId] = useState(0);
  const [priorityId, setPriorityId] = useState(0);
  const [scheduleStatusId, setScheduleStatusId] = useState(0);

  const [topic, setTopic] = useState('');
  const [description, setDescription] = useState('');

  const [
    initialRegistrationDate, setInitialRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);
  const [
    finalRegistrationDate, setFinalRegistrationDate,
  ] = useState<string | Date | Date[] | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [attorneysOptions, setAttorneysOptions] = useState<IOptions[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [assistantsOptions, setAssistantsOptions] = useState([{}]);
  const [customersOptions, setCustomersOptions] = useState([{}]);
  const [sectorOptions, setSectorOptions] = useState([{}]);
  const [inChargeOptions, setInChargeOptions] = useState<IInChargeType[]>([]);

  let loggedUserLevel = '';
  let loggedUserId = 0;
  // const accessData = sessionStorage.getItem('@Jurisnet:access');
  const accessData = localStorage.getItem('@Jurisnet:access');

  if (typeof accessData === 'string') {
    const access = JSON.parse(accessData);
    loggedUserLevel = access.nivelusuario;
    loggedUserId = Number(access.usuario_logado);
  }

  let userTypeDefinition = '';
  switch (loggedUserLevel) {
    case 'Administrador':
      userTypeDefinition = 'global|0';
      break;
    case 'Advogado':
      userTypeDefinition = `adv|${loggedUserId}`;
      break;
    case 'Assistente':
      userTypeDefinition = `adm|${loggedUserId}`;
      break;
    default:
      userTypeDefinition = 'global|0';
      break;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [inCharge, setInCharge] = useState<any>(userTypeDefinition);
  const [dateFilterType, setDateFilterType] = useState('data');

  const [showDate, setShowDate] = useState(true);
  const [showPeriod, setShowPeriod] = useState(false);

  const dateFilterTypeOptions = [
    { name: 'Data', value: 'data', style: 'font-size: small;' },
    { name: 'Período', value: 'periodo', style: 'font-size: small;' },
  ];

  const validationSchema = null;

  const optionsScheduleStatus = [
    { name: 'Todos', value: 0 },
    { name: 'A iniciar', value: 1 },
    { name: 'Em andamento', value: 2 },
    { name: 'Em espera', value: 4 },
    { name: 'Concluída', value: 3 },
  ];

  const optionsPriority = [
    { name: 'Todas', value: 0 },
    { name: 'Alta', value: 1 },
    { name: 'Normal', value: 2 },
    { name: 'Baixa', value: 3 },
  ];

  const optionsScheduleType = [
    { name: 'Todas', value: 0 },
    { name: 'Atividade', value: 1 },
    { name: 'Reunião', value: 2 },
  ];

  useEffect(() => {
    (async () => {
      await api.get('customers/show/all').then((response) => {
        response.data.map((customer:
        {
          cliente_id: number,
          cliente_nome:string
        }) => (
          customersOptions.push({
            name: customer.cliente_nome,
            value: customer.cliente_id,
          })
        ));
      });
      customersOptions.splice(0, 1);
      setCustomersOptions(customersOptions);
    })();
  }, [customersOptions]);

  useEffect(() => {
    (async () => {
      await api.get('/management/attorneys/show/inchargelawsuits/attorneys').then((response) => {
        if (response.data.length > 0) {
          sectorOptions.push({
            name: 'Todos',
            value: 'all',
          });
          response.data.map((sector: {
            setor_adv: string
          }) => (
            sectorOptions.push({
              name: sector.setor_adv,
              value: sector.setor_adv,
            })
          ));
        }
      });

      await api.get('/management/attorneys/show/inchargelawsuits/others').then((response) => {
        if (response.data.length > 0) {
          response.data.forEach((sector: {
            setor_adm: string
          }) => {
            if (sectorOptions.indexOf(sector.setor_adm) === -1) {
              sectorOptions.push({
                name: sector.setor_adm,
                value: sector.setor_adm,
              });
            }
          });
        }
      });

      sectorOptions.splice(0, 1);
      setSectorOptions(sectorOptions);
    })();
  }, [sectorOptions]);

  const filterAttorneysInCharge = async (sector: string | string[]) => {
    let isDisabled = true;

    inChargeOptions.push(
      {
        label: 'Todos',
        items: [
          { label: 'Todos', value: 'global|0' },
          { label: 'Todos - exceto estagiários', value: 'global|99997' },
          { label: 'Todos - exceto assistentes', value: 'global|99998' },
          { label: 'Todos - exceto estagiários e assistentes', value: 'global|99999' },
        ],
      },
    );

    await api.get(`management/attorneys/show/all/active/lawsuit/${sessionStorage.getItem('categoria')}/${sessionStorage.getItem('setor')}`).then((response) => {
      const typeInCharge = 'adv|';

      attorneysOptions.splice(0, attorneysOptions.length);
      response.data.forEach((attorney:
      {
        advogado_id: number,
        advogado_nome:string,
        advogado_setor: string;
      }) => {
        if (sector.includes(attorney.advogado_setor)) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
        if (sector === 'all') {
          isDisabled = false;
        }
        attorneysOptions.push({
          label: `${attorney.advogado_nome} (Advogado)`,
          value: typeInCharge.concat(attorney.advogado_id.toString()),
          disabled: isDisabled,
          workingsector: attorney.advogado_setor,
        });
      });
      attorneysOptions.splice(0, 1);

      inChargeOptions.push({
        label: 'Advogados',
        items: attorneysOptions,
      });
    });

    await api.get('management/assistants/show/all/active').then((response) => {
      const typeInCharge = 'adm|';
      response.data.forEach((assistant:
      {
        administrador_id: number,
        administrador_nome: string,
        administrador_setor: string,
      }) => {
        if (sector.includes(assistant.administrador_setor)) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
        if (sector === 'all') {
          isDisabled = false;
        }
        assistantsOptions.push({
          label: `${assistant.administrador_nome} (Assistente)`,
          value: typeInCharge.concat(assistant.administrador_id.toString()),
          disabled: isDisabled,
          workingsector: assistant.administrador_setor,
          style: 'visibility: hidden',
        });
      });
      assistantsOptions.splice(0, 1);
      inChargeOptions.push({
        label: 'Assistentes/Estagiários',
        items: assistantsOptions,
      });
    });

    setInChargeOptions(inChargeOptions);
  };

  useEffect(() => {
    if (inChargeOptions.length < 1) {
      filterAttorneysInCharge('all');
    }
  });

  const handleOnSubmit = async (
    values: SearchData,
    { setSubmitting }: FormikHelpers<SearchData>,
  ) => {
    try {
      const searchFormData = {
        inCharge: userTypeDefinition,
        topic,
        description,
        typeId,
        priorityId,
        scheduleStatusId,
        dateFilterType,
        schedule_date_inicio: initialRegistrationDate,
        schedule_date_final: finalRegistrationDate,
      };

      history.push({
        pathname: '/schedule',
        state: searchFormData,
      });

      setSubmitting(false);
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Ocorreu um problema',
        description:
              'Tente repetir a pesquisa ou contate o administrador.',
      });
    }
  };

  return (
    <Container>
      <div className="card">
        <header>
          <h3>Consultar agendamentos</h3>
        </header>

        <Formik
          onSubmit={handleOnSubmit}
          validationSchema={validationSchema}
          enableReinitialize
          initialValues={initialValues}
        >
          {({
            isSubmitting,
            handleSubmit,
            handleReset,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="fluid formgrid grid p-mt-10">
                <div className="col-12 md:col-6 colum-spacer-right">
                  <div className="field grid">
                    {loggedUserLevel === 'Administrador' ? (
                      <div className="col-12 md:col-12">
                        <label htmlFor="inChargeDropDown">
                          Responsável
                        </label>
                        <Dropdown
                          id="inChargeDropDown"
                          name="inChargeDropDown"
                          className="inputfield w-full"
                          value={inCharge}
                          options={inChargeOptions || {}}
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                          onChange={(e: {value: any}) => setInCharge(e.value)}
                          optionLabel="label"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          filter
                          filterBy="label"
                        />
                      </div>
                    ) : null}
                    <div className="col-12 md:col-12">
                      <label htmlFor="proc_reg_outros">
                        Assunto
                      </label>
                      <InputText
                        id="topic"
                        name="topic"
                        className="inputfield w-full"
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                      />
                    </div>

                    <div className="col-12 md:col-12">
                      <label htmlFor="description">
                        Detalhamento
                      </label>
                      <InputTextarea
                        id="description"
                        name="description"
                        className="inputfield w-full"
                        value={description || ''}
                        onChange={(e) => setDescription(e.target.value)}
                        rows={8}
                        cols={30}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 md:col-6 column-divider">
                  <div className="field grid">

                    <div className="col-12 md:col-12">
                      <label htmlFor="schedule_type_id">Tipo da atividade</label>
                      <SelectButton
                        id="schedule_type_id"
                        value={typeId}
                        options={optionsScheduleType}
                        optionLabel="name"
                        optionValue="value"
                        onChange={(e) => setTypeId(e.value)}
                      />
                    </div>
                    <div className="col-12 md:col-12">
                      <label htmlFor="schedule_priority_id">Prioridade</label>
                      <SelectButton
                        id="schedule_priority_id"
                        value={priorityId}
                        options={optionsPriority}
                        optionLabel="name"
                        optionValue="value"
                        onChange={(e) => setPriorityId(e.value)}
                      />
                    </div>
                    <div className="col-12 md:col-12">
                      <label htmlFor="schedule_status_id">Situação da atividade</label>
                      <SelectButton
                        id="schedule_status_id"
                        value={scheduleStatusId}
                        options={optionsScheduleStatus}
                        optionLabel="name"
                        optionValue="value"
                        onChange={(e) => setScheduleStatusId(e.value)}
                      />
                    </div>

                    <div className="col-12 md:col-12">
                      <label htmlFor="schedule_date_inicio">
                        Data da atividade/reunião
                        { ' ' }
                        <Tooltip target=".infoText">
                          <strong>Selecione data específica ou período</strong>
                          <br />
                          <strong>Seleção data</strong>
                          <br />
                          <em>
                            Use para intervalos com seleção específica de datas
                          </em>
                          <br />
                          <br />
                          <strong>Seleção período</strong>

                          <br />
                          <em>
                            Para período inicial e final do mesmo mês,
                            <br />
                            selecione apenas o período inicial para que o intervalo
                            <br />
                            seja o primeiro
                            e último dia do mês selecionado
                          </em>
                        </Tooltip>
                        <i
                          className="infoText pi pi-info-circle"
                          data-pr-position="bottom"
                        />
                      </label>
                    </div>
                    <div className="col-12 md:col-12" style={{ marginBottom: '15px' }}>
                      <SelectButton
                        id="date_filter_type"
                        value={dateFilterType}
                        options={dateFilterTypeOptions}
                        optionLabel="name"
                        onChange={(e) => {
                          setDateFilterType(e.value);
                          if (e.value === 'data') {
                            setShowDate(true);
                            setShowPeriod(false);
                          } else {
                            setShowDate(false);
                            setShowPeriod(true);
                          }
                        }}
                        style={{ padding: '0.5rem 0.79rem 0 0' }}
                      />
                    </div>
                    {showPeriod ? (
                      <>
                        <div id="periodo_ini" className="col-12 md:col-6">
                          <Calendar
                            inputId="schedule_date_inicio_mes_ano"
                            name="schedule_date_inicio_mes_ano"
                            className="inputfield w-full"
                            value={null}
                            onChange={(e : CalendarChangeEvent) => {
                              if (e.value !== undefined && e.value !== null) {
                                setInitialRegistrationDate(e.value);
                              }
                            }}
                            keepInvalid
                            showIcon
                            showButtonBar
                            showOnFocus={false}
                            mask="99/9999"
                            dateFormat="mm/yy"
                            yearRange="1980:2030"
                            placeholder="Período inicial"
                            view="month"
                            yearNavigator
                          />
                        </div>
                        <div id="periodo_fim" className="col-12 md:col-6">
                          <label htmlFor="schedule_date_final_mes_ano">
                            <Calendar
                              inputId="schedule_date_final_mes_ano"
                              name="proc_data_ajuiz_final"
                              className="inputfield w-full"
                              value={null}
                              onChange={(e : CalendarChangeEvent) => {
                                if (e.value !== undefined && e.value !== null) {
                                  setFinalRegistrationDate(e.value);
                                }
                              }}
                              keepInvalid
                              showIcon
                              showButtonBar
                              showOnFocus={false}
                              mask="99/9999"
                              dateFormat="mm/yy"
                              yearRange="1980:2030"
                              placeholder="Período final"
                              view="month"
                              yearNavigator
                            />
                          </label>
                        </div>
                      </>
                    ) : null }
                    {showDate ? (
                      <>
                        <div id="data_ini" className="col-12 md:col-6">
                          <Calendar
                            inputId="schedule_date_inicio"
                            name="schedule_date_inicio"
                            className="inputfield w-full"
                            value={null}
                            onChange={(e : CalendarChangeEvent) => {
                              if (e.value !== undefined && e.value !== null) {
                                setInitialRegistrationDate(e.value);
                              }
                            }}
                            keepInvalid
                            showIcon
                            showButtonBar
                            showOnFocus={false}
                            mask="99/99/9999"
                            dateFormat="dd/mm/yy"
                            yearRange="1980:2030"
                            placeholder="Data inicial"
                          />
                        </div>
                        <div id="data_fim" className="col-12 md:col-6">
                          <label htmlFor="schedule_date_final">
                            <Calendar
                              inputId="schedule_date_final"
                              name="schedule_date_final"
                              className="inputfield w-full"
                              value={null}
                              onChange={(e : CalendarChangeEvent) => {
                                if (e.value !== undefined && e.value !== null) {
                                  setFinalRegistrationDate(e.value);
                                }
                              }}
                              keepInvalid
                              showIcon
                              showButtonBar
                              showOnFocus={false}
                              mask="99/99/9999"
                              dateFormat="dd/mm/yy"
                              yearRange="1980:2030"
                              placeholder="Data final"
                            />
                          </label>
                        </div>
                      </>
                    ) : null }
                  </div>
                </div>

                <div className="col-12 p-mt-5">
                  <div className="flex align-content-center justify-content-center field">
                    <Button
                      icon="pi pi-check"
                      iconPos="left"
                      label="Pesquisar processos"
                      className="p-mr-2"
                      type="submit"
                      disabled={isSubmitting}
                    />
                    <Button
                      icon="pi pi-undo"
                      iconPos="left"
                      label="Limpar campos"
                      className="p-button-secondary p-mr-2"
                      type="button"
                      onClick={handleReset}
                    />
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>

    </Container>

  );
};

export default SearchSchedule;
